export default __webpack_public_path__ + "assets/models/ad44bbc6a3f9bc19a235f57d01c3e730.glb";